/**
 * 이미지 orientation 체크
 * 1) data-image-orientation-blur="true" 속성이 있는 요소 내부의 .__og 이미지가 세로로 더 긴 경우 --portrait 클래스 추가
 * 2) 세로로 긴 이미지가 양쪽 블러 영역이 33% 이상 생기지 않도록 --extra-tall 클래스 추가
 */
window.addEventListener('SITE_START', () => {
  initImageOrientation();
});

function initImageOrientation() {
  const containers = document.querySelectorAll('[data-image-orientation-blur="true"]');
  if (!containers.length) return;

  containers.forEach((container) => {
    const ogImage = container.querySelector('.__og');

    if (ogImage) {
      checkOrientation(ogImage, container);
    }
  });

  function checkOrientation(img, container) {
    if (img.complete && img.naturalWidth > 0) {
      applyPortraitClass(img, container);
    } else {
      img.addEventListener('load', () => applyPortraitClass(img, container), { once: true });
    }
  }

  function applyPortraitClass(img, container) {
    // 1) 기준이 1:1 인 경우 세로 이미지 판별
    if (img.naturalHeight > img.naturalWidth) {
      container.classList.add('--portrait');

      // 2) 블러 영역이 양쪽 33% 이상 생기지 않도록 체크
      // 컨테이너 크기 기준으로 이미지가 세로로 과도하게 긴 경우 --extra-tall 클래스 추가
      const LIMIT_PERCENT = 25;
      const containerWidth = container.offsetWidth;
      const containerHeight = container.offsetHeight;

      // object-fit: contain 으로 들어갈 때 시각적으로 보이는 이미지 영역 계산
      const imageAspect = img.naturalWidth / img.naturalHeight;

      // 세로 이미지: 상하에 맞춤, 좌우 여백
      const renderedWidth = containerHeight * imageAspect;
      const blurWidthEachSide = (containerWidth - renderedWidth) / 2;
      const blurPercent = (blurWidthEachSide / containerWidth) * 100;

      if (blurPercent >= LIMIT_PERCENT) {
        container.classList.add('--extra-tall');
      }
    }
  }
}
